import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { useAuth } from "@/context/AuthContext";

export const AdminLogin = ({ onToken }) => {
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, user } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { password: pwd });
      onToken(data.token);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-[#F5F5F7] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="card-soft w-full max-w-sm p-8 hover:translate-y-0">
        <Logo />
        <h1 className="font-display mt-8 flex items-center gap-2 text-2xl font-bold tracking-tight"><Lock className="h-5 w-5 text-[#0066FF]" /> Area riservata</h1>
        <p className="mt-2 text-sm text-[#52525b]">Inserisci la password admin per vedere gli iscritti.</p>
        {user && !user.is_admin && (
          <p className="mt-4 rounded-xl bg-amber-50 p-3 text-sm text-amber-900" data-testid="admin-not-allowed">
            Sei entrato con Google come <b>{user.email}</b>, che non è un account admin. Usa la password oppure fai aggiungere questa email agli admin.
          </p>
        )}
        <input
          type="password"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          placeholder="Password"
          required
          className="mt-6 h-12 w-full rounded-xl border border-[#e2e2e6] bg-[#F5F5F7] px-4 outline-none focus:border-[#0066FF] focus:bg-white focus:ring-4 focus:ring-[#0066FF]/10"
          data-testid="admin-password-input"
        />
        <button type="submit" disabled={busy} className="btn-blu mt-4 h-12 w-full text-sm" data-testid="admin-login-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entra"}
        </button>
        <button type="button" onClick={() => login("/admin")} className="mt-3 w-full text-center text-sm font-medium text-[#52525b] hover:text-[#0066FF]" data-testid="admin-google-login">
          Oppure accedi con Google (account admin)
        </button>
      </form>
    </main>
  );
};
